import { useApolloClient } from "@apollo/client";
import {
  UseDownloadQuotePdfOptions_QuoteFragment,
  useUseDownloadQuotePdfOptionsQuery,
} from "./useDownloadQuotePdfOptions.generated.js";
import { getDataOrNull } from "@msys/common";

export const useDownloadQuotePdfOptions = ({
  doc,
}: {
  doc: UseDownloadQuotePdfOptions_QuoteFragment | undefined;
}) => {
  const client = useApolloClient();
  const query = useUseDownloadQuotePdfOptionsQuery({
    client,
  });

  const templateOriginQuoteId = doc?.templateOriginQuoteId;
  const hasSelectedCalculations = Boolean(doc?.agreedCalculation);

  const contractingPdfs =
    getDataOrNull(query.data?.organisationContractingPdfs)?.contractingPdfs ??
    [];
  const sexyQuotePdfTemplates = query.data?.organisationSexyQuotesConfig
    ? (getDataOrNull(query.data?.organisationSexyQuotesConfig)?.pdfTemplates ??
      [])
    : [];
  const pdfGeneratorTemplates = query.data?.organisationPdfGeneratorTemplates
    ? (getDataOrNull(query.data?.organisationPdfGeneratorTemplates)
        ?.templates ?? [])
    : [];
  const sexyQuotePdfTemplatesFiltered = sexyQuotePdfTemplates.filter(
    t =>
      templateOriginQuoteId &&
      (t.templateIds ?? []).includes(templateOriginQuoteId)
  );
  const hasContractingTemplates = contractingPdfs.length > 0;
  const hasPdgGeneratorTemplates = pdfGeneratorTemplates.length > 0;
  const hasSexyQuotePdfTemplates = sexyQuotePdfTemplatesFiltered.length > 0;
  const hasPdfGeneratorIntegration = Boolean(
    getDataOrNull(query.data?.organisationPdfGeneratorTemplates)
      ?.integrationEnabled
  );

  return {
    hasContractingTemplates,
    hasPdgGeneratorTemplates,
    hasSexyQuotePdfTemplates,
    hasPdfGeneratorIntegration,

    hasSelectedCalculations,

    contractingPdfs,
    sexyQuotePdfTemplates: sexyQuotePdfTemplatesFiltered,
    pdfGeneratorTemplates,

    loading: query.loading,
  };
};
